import { ColDef } from 'ag-grid-community'
import { getFormattedDate, getTypeKey } from 'utils'
import TitleWithSubtitleCell from 'components/table/TitleWithSubtitleCell'
import { singleBrandClientV5 } from 'utils/utils.d'
import { unknown } from 'utils/constants'
import type { FEApiError } from 'utils/errorHandling'

export const handleErrorFromClientAPI = (
  error: FEApiError,
  setApiResponseError: (value: React.SetStateAction<string | undefined>) => void,
) => {
  const isErrorArray = !!error?.errors && !error?.message
  if (isErrorArray) throw error
  const errorMessage = error.message
  setApiResponseError(errorMessage)
  throw errorMessage
}

export const columnStructureBrands: ColDef<singleBrandClientV5>[] = [
  {
    headerName: 'Brand name',
    field: getTypeKey<singleBrandClientV5>('brand_name'),
    sortable: true,
    flex: 1,
    resizable: true,
  },
  {
    headerName: 'Last updated',
    field: getTypeKey<singleBrandClientV5>('updated_at'),
    sortable: true,
    flex: 1,
    resizable: true,
    cellRenderer: ({ data }: { data: singleBrandClientV5 }) => (
      <TitleWithSubtitleCell
        title={getFormattedDate(data.updated_at || data.created_at)}
        subTitle={data?.update_info?.user_name || unknown}
      />
    ),
  },
]
